import { ISanPhamPhamVi } from "../../model/respone/san-pham/ISanPhamPhamVi"
import { apiClient, formatQueryString } from "../apiClient"

export const SAN_PHAM_PHAM_VI_API_RESOURCE = "san-pham-pham-vi"
export const sanPhamPhamViApi = {
    GetAll: (params?: { dm_coso_id?: number }) => {
        const query = params ? formatQueryString(params) : "";
        return apiClient.get(`${SAN_PHAM_PHAM_VI_API_RESOURCE}${query ? `?${query}` : ""}`);
    },
    GetById: (id: number) => apiClient.get(`${SAN_PHAM_PHAM_VI_API_RESOURCE}/${id}`),
    Insert: (payload: ISanPhamPhamVi) => apiClient.post(`${SAN_PHAM_PHAM_VI_API_RESOURCE}`, payload),
    Update: (payload: ISanPhamPhamVi) => apiClient.put(`${SAN_PHAM_PHAM_VI_API_RESOURCE}`, payload),
    Delete: (id: number) => apiClient.delete(`${SAN_PHAM_PHAM_VI_API_RESOURCE}/${id}`),
}
